import { useTranslation } from "@coworker/locales";
import TitledBoxedText from "@coworker/apprestructured/src/task-management/components/TitledBoxedText/TitledBoxedText";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type TitledBoxedTextViewerFragmentConfigProps = {
  // Translation key for the title
  title: string;
  field: string;
};

type TitledBoxedTextViewerFragmentProps = {
  configProps: TitledBoxedTextViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function TitledBoxedTextViewerFragment({
  configProps,
  commonProps,
}: TitledBoxedTextViewerFragmentProps) {
  const { field, title } = configProps;
  const { task } = commonProps;
  const text = getTypedValue<string>(getByPath(task, field));

  const { t } = useTranslation();

  if (isLoading(text) || text.length === 0) {
    return null;
  }

  return <TitledBoxedText title={t(title)} text={text} />;
}

export default TitledBoxedTextViewerFragment;
